// extracted by mini-css-extract-plugin
module.exports = {"base":"CheckIcon-base-6c068b4a8c7dd643d4abca8c16c4f7f7"};